/* Transfers selected value from radio_field() to hidden <input> on the disregarded entity questionnaire. */
"use strict";
define('components/form_components/questionnaire_disregarded_entities',[], function() {
    var toggleDisregardedEntityComponent = {
        init: function(formNode) {
            var self = this;
            formNode.find('div.deform-seq-item').each(function() {
                self.setUpLocationSequenceItem($(this));
            });
        },

        /* Update the input when user clicks radio_buttons. */
        setUpLocationSequenceItem: function(sequenceItem) {
            var is_disregarded_entity_input = sequenceItem.find('input[name="is_disregarded_entity"]');
            sequenceItem.find('[data-is-disregarded-entity]').on('click', function() {
                is_disregarded_entity_input.val($(this).data('is-disregarded-entity'));
            });

            sequenceItem.find('[data-is-disregarded-entity=' + is_disregarded_entity_input.val() + ']').click();

        }
    };
    return toggleDisregardedEntityComponent;
});


